import { Injectable } from "@angular/core";
import { IconSettingsService } from "@progress/kendo-angular-icons";
import { SVGIcon } from "@progress/kendo-svg-icons";
import * as allSVGIcons from "@progress/kendo-svg-icons";

@Injectable()
export class IconService extends IconSettingsService {
    private svgDictionary: { [key: string]: SVGIcon } = {
        "caret-alt-down": allSVGIcons.minusIcon,
        "caret-alt-up": allSVGIcons.plusIcon,
        "close": allSVGIcons.xIcon,
        'refresh': allSVGIcons.arrowRotateCwIcon
    };

    public getSvgIcon(svgIconName: string): SVGIcon {
        return this.svgDictionary[svgIconName] || super.getSvgIcon(svgIconName);
    }

    private iconDictionary: { [key: string]: string } = {
        'caret-alt-down': 'ms-Icon ms-Icon--CaretSolidDown', //'k-icon k-font-icon k-i-caret-alt-down',
        'close': 'ms-Icon ms-Icon--ChromeClose', //'k-icon k-font-icon k-i-close',
        //'refresh': 'k-icon k-font-icon k-i-refresh'
    };

    public getCustomFontIconClass(iconName: string): string {
        if (iconName === undefined) {
            return null;
        }
        return this.iconDictionary[iconName] || super.getCustomFontIconClass(iconName);
    }
}
